import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
// import Button from 'material-ui/Button'
import {Button} from '../../components'
import {CircularProgress} from 'material-ui/Progress'

const styles = theme => ({
  VBLoadingButtonWrapper: {
    position: 'relative',
    display: 'inline-block',
    textAlign: 'center',
  },
  VBLoadingButtonProgress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
})

const LoadingButton = (props) => {
  const {classes, divProps, progressProps, isLoading, children, disabled, ...buttonProps} = props
  return (
    <div className={props.classes.VBLoadingButtonWrapper} {...divProps}>
      <Button
        {...buttonProps}
        disabled={isLoading || disabled}
      >
        {children}
      </Button>
      {
        isLoading &&
        <CircularProgress
          size={24}
          className={classes.VBLoadingButtonProgress}
          {...progressProps}
        />
      }
    </div>
  )
}

LoadingButton.propTypes = {
  isLoading: PropTypes.bool,
  divProps: PropTypes.object,
  progressProps: PropTypes.object,
}

export default withStyles(styles, {withTheme: true})(LoadingButton)



// WEBPACK FOOTER //
// ./src/common/components/LoadingButton.js